import { useEffect, useRef } from 'react';

// This will track Comscore page events for each client-side routed page, excluding the first pageload
// We omit the first pageload because the Comscore script itself already counts this page
export function useComscorePageTracking(trackComscoreEvent: () => void, pathname: string) {
  const isInitialLoad = useRef(true);
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
    } else {
      trackComscoreEvent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- callers pass an inline function, so depending on it would fire on every render
  }, [pathname]);
}
